import { jsx, jsxs } from "react/jsx-runtime";
import "react";
import { Heading } from "../Heading/Heading.mjs";
import Starburst from "../Starburst/Starburst.mjs";
import UserPointsBadge from "../UserPointsBadge/UserPointsBadge.mjs";
const Greeter = ({ user, config })=>/*#__PURE__*/ jsx("a", {
        className: "ptw-mb-4 ptw-flex ptw-cursor-pointer ptw-items-center ptw-justify-between ptw-rounded-[12px] ptw-bg-[linear-gradient(90deg,_#E91C24_0%,_#BA161D_100%)] ptw-px-5 ptw-pb-4 ptw-pt-3 ptw-no-underline",
        href: config.pup.url,
        target: "_blank",
        rel: "noreferrer",
        children: /*#__PURE__*/ jsx("div", {
            className: "ptw-w-full md:ptw-w-auto",
            children: /*#__PURE__*/ jsx("div", {
                className: "ptw-mb-3 ptw-flex ptw-flex-col ptw-gap-4",
                children: /*#__PURE__*/ jsxs("div", {
                    className: "ptw-flex ptw-flex-col ptw-gap-3",
                    children: [
                        user?.name && /*#__PURE__*/ jsxs(Heading, {
                            as: "h1",
                            size: "titleSmall",
                            weight: "bold",
                            className: "ptw-mb-2 ptw-mt-3 ptw-flex ptw-min-h-5 ptw-items-center ptw-gap-2 ptw-text-secondary-text",
                            children: [
                                /*#__PURE__*/ jsx("span", {
                                    children: `Hi, ${user.name}`
                                }),
                                /*#__PURE__*/ jsx(Starburst, {
                                    width: 20,
                                    height: 20,
                                    className: "ptw-ml-4 ptw-inline-block ptw-h-[24px] ptw-w-[24px] ptw-align-middle"
                                })
                            ]
                        }),
                        /*#__PURE__*/ jsx("div", {
                            className: "ptw-relative ptw-flex ptw-items-center",
                            children: /*#__PURE__*/ jsx(UserPointsBadge, {
                                theme: "white",
                                points: user.points
                            })
                        })
                    ]
                })
            })
        })
    });
export { Greeter };
